import React from 'react'

import IncidentDetailsSection from '../../incidents/components/IncidentDetailsSection'
//import SendToPalmettoButton from './SendToPalmettoButton'

import { useSelectedIncident } from '../hooks'

import styles from './IncidentDetails.module.css'

const detailFormat = (detail) =>
  (detail && detail.trim ? detail.trim() : detail) || '-'
const detailGroupFormat = (group) => {
  Object.keys(group).forEach((key) => (group[key] = detailFormat(group[key])))
  return group
}

const IncidentDetails = () => {
  const incident = useSelectedIncident()
  if (!incident) return null

  const {
    agencyName,
    incidentDate,
    incidentNumber,
    crimeCatDescr,
    primaryOfficerName1,
    primaryUnitId,
    location,
    apartment,
    commonPlace,
    building,
    floor,
    cityName,
    callerAddress,
    callerName,
    callerPhone,
    allComments,
    //sentToPalmetto,
  } = incident

  /* eslint-disable */
  const basic = detailGroupFormat({
    ['Agency']: agencyName,
    ['Date/Time']: incidentDate,
    ['Incident Number']: incidentNumber,
    ['Description']: crimeCatDescr,
    ['Officer']: primaryOfficerName1,
    ['Primary Unit Id']: primaryUnitId,
  })

  const address = detailGroupFormat({
    ['Street']: location,
    ['Apt. Number']: apartment || commonPlace,
    ['Building']: building || floor,
    ['City']: cityName,
  })

  const caller = detailGroupFormat({
    ['Address']: callerAddress,
    ['Name']: callerName,
    ['Phone']: callerPhone,
  })
  /* eslint-enable */

  return (
    <div className={styles.details}>
      <IncidentDetailsSection title="Basic" details={basic} />
      <IncidentDetailsSection title="Address" details={address} />
      <IncidentDetailsSection title="Caller" details={caller} />
      <div className={styles.sectionTitle}>Comments</div>
      <span className={styles.comments}>{allComments}</span>
      {/* <SendToPalmettoButton sentToPalmetto={sentToPalmetto} /> */}
    </div>
  )
}

export default IncidentDetails
